import { http } from '@shared/api/http-client';
import type { EngagementReport } from '@features/engagement/model/engagement.types';

export const engagementApi = {
  /** The whole report — every user plus the overview. Filtering happens client-side. */
  report(): Promise<EngagementReport> {
    return http.get<EngagementReport>('/budgeting/engagement');
  },
};
